<button type="button" [disabled]="disabled" [ngClass]="type" [title]="title"><ng-content></ng-content></button>